/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class WebHookEventGroupType.
* @enum {}
* @readonly
*/
export default class WebHookEventGroupType {
    
        /**
         * value: 1
         * @const
         */
        "1" = 1;

    
        /**
         * value: 2
         * @const
         */
        "2" = 2;

    
        /**
         * value: 3
         * @const
         */
        "3" = 3;

    
        /**
         * value: 4
         * @const
         */
        "4" = 4;

    
        /**
         * value: 5
         * @const
         */
        "5" = 5;

    
        /**
         * value: 6
         * @const
         */
        "6" = 6;

    
        /**
         * value: 7
         * @const
         */
        "7" = 7;

    
        /**
         * value: 8
         * @const
         */
        "8" = 8;

    

    /**
    * Returns a <code>WebHookEventGroupType</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/WebHookEventGroupType} The enum <code>WebHookEventGroupType</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

